import {storeInstance} from '@aofl/store/dist/legacy';
import {
  sdoNs,
  rosterErrors,
  pages,
  jobStatuses,
  thirdPartyRosterSystemsMap,
  jobTypes
} from './constants-enumerate';
import {deepAssign} from '@aofl/object-utils';
import {UserJobs} from './user-jobs';
import './session-sdo';
import {getLocaleDate} from './get-locale-date';
// import {deepAssign} from '@aofl/object-utils';

const ns = sdoNs.USER_JOBS;
const DATE_SETTING = {year: 'numeric', month: 'short', day: 'numeric'};

const ROSTER_ROW_ERRORS = {
  [rosterErrors.AMBIGUOUS]: true,
  [rosterErrors.DUPLICATE_EMAIL]: true,
  [rosterErrors.DUPLICATE_PHONE]: true,
  [rosterErrors.EMAIL_IN_USE_BY_ADMIN]: true,
  [rosterErrors.ID_MISMATCH]: true,
  [rosterErrors.ID_REUSE_MISMATCH]: true,
  [rosterErrors.INVALID_EMAIL]: true,
  [rosterErrors.INVALID_COUNTRY_CODE]: true,
  [rosterErrors.INVALID_EXTERNAL_ID_LENGTH]: true,
  [rosterErrors.INVALID_LANGUAGE]: true,
  [rosterErrors.INVALID_MONTH]: true,
  [rosterErrors.INVALID_PHONE]: true,
  [rosterErrors.INVALID_NAME]: true,
  [rosterErrors.INVALID_SWAP_OF_GROUP_LEVEL]: true,
  [rosterErrors.INVALID_YEAR]: true,
  [rosterErrors.NO_EMAIL_OR_PHONE]: true,
  [rosterErrors.REPLACEMENT_ID_MISMATCH]: true,
  [rosterErrors.REPLACEMENT_ID_USED]: true,
  [rosterErrors.REPLACEMENT_ID_ARCHIVED]: true,
  [rosterErrors.REQUIRED]: true,
  [rosterErrors.MISSING_HEADER]: true,
  [rosterErrors.INVALID_REFERENCE]: true,
  [rosterErrors.NOT_EQUAL_ERROR]: true,
  [rosterErrors.NO_SUCH_CHOICE_ERROR]: true,
  [rosterErrors.MISSING_FIELD_ERROR]: true,
  [rosterErrors.IS_BLANK_ERROR]: true,
  [rosterErrors.INVALID_PHONE_FORMAT_ERROR]: true,
  [rosterErrors.INVALID_DATE_FORMAT_ERROR]: true,
  [rosterErrors.INVALID_DATE_ERROR]: true,
  [rosterErrors.INVALID_TIME_ERROR]: true,
  [rosterErrors.FILE_NOT_FOUND_ERROR]: true,
  [rosterErrors.NO_SUCH_FIELD_ERROR]: true,
  [rosterErrors.ID_MISMATCH_NEW]: true,
  [rosterErrors.UNKNOWN_HEADER]: true,
  [rosterErrors.INVALID_USER_ROLE_REFERENCE]: true,
  [rosterErrors.INCOMPLETE_DELETION]: true,
  [rosterErrors.INVALID_CLASS_PARENT]: true,
  [rosterErrors.INVALID_ORG_STATUS]: true,
  [rosterErrors.INVALID_ORG_STRUCTURE]: true,
};

const sdo = {
  namespace: ns,
  mutations: {
    init() {
      return {
        jobs: [],
        rosterJobs: []
      };
    },
    setJobs(subState, jobs) {
      if (JSON.stringify(jobs) !== JSON.stringify(subState.jobs)) {
        subState = Object.assign({}, subState, {jobs});
      }
      return subState;
    },
    setRosterJobs(subState, rosterJobs) {
      if (JSON.stringify(rosterJobs) !== JSON.stringify(subState.rosterJobs)) {
        subState = Object.assign({}, subState, {rosterJobs});
      }
      return subState;
    },
    setDismissedJob(subState, id) {
      const cached = localStorage.getItem('dismissed_jobs');
      let dismissedJobs = [];
      if (cached !== null) {
        dismissedJobs = JSON.parse(cached);
      }
      dismissedJobs.push(id);

      localStorage.setItem('dismissed_jobs', JSON.stringify(dismissedJobs));

      return subState;
    },
    setSeenJobs(subState, ids) {
      const cached = localStorage.getItem('seen_bell_jobs');
      let seenJobs = [];

      if (cached !== null) {
        seenJobs = JSON.parse(cached);
      }

      const set = new Set([...seenJobs, ...ids]);
      localStorage.setItem('seen_bell_jobs', JSON.stringify(Array.from(set)));

      return subState;
    }
  },
  decorators: [
    (nextState) => {
      const state = storeInstance.getState();
      const nextSubState = nextState[ns];
      const subState = state[ns];

      if (nextSubState.rosterJobs.length > 0 && (
        nextState[sdoNs.SESSION].locale !== state[sdoNs.SESSION].locale ||
        nextSubState.rosterJobs !== subState.rosterJobs)) {
        const rosterJobs = [];
        for (let i = 0; i < nextSubState.rosterJobs.length; i++) {
          let job = nextSubState.rosterJobs[i];
          const startTime = new Date(job.start_timestamp * 1000);
          let $endDateTime = null;
          if (job.end_timestamp) {
            const endTime = new Date(job.end_timestamp * 1000);
            $endDateTime = endTime.toLocaleString(nextState[sdoNs.SESSION].locale);
          }

          job = Object.assign({}, job, {
            $startTime: startTime.toLocaleDateString(nextState[sdoNs.SESSION].locale, DATE_SETTING),
            $endDateTime,
          });
          rosterJobs.push(job);
        }
        nextState = deepAssign(nextState, ns, {rosterJobs});
      }

      return nextState;
    },
    (nextState) => { // @notificationBellJobs
      const state = storeInstance.getState();
      const nextSubState = nextState[ns];
      const subState = state[ns];

      const seenCached = localStorage.getItem('seen_bell_jobs');
      let seenJobs = [];
      if (seenCached !== null) {
        seenJobs = JSON.parse(seenCached);
      }
      let $unseenCount = 0;

      if (nextSubState.jobs.length >= 0 && (
        (nextState[sdoNs.SESSION]?.locale !== state[sdoNs.SESSION]?.locale) ||
        nextSubState.jobs !== subState.jobs ||
        seenJobs !== subState.$seenBellJobs)) {
        const $notificationBellJobs = [];
        for (let i = 0; i < nextSubState.jobs.length; i++) {
          let job = nextSubState.jobs[i];

          const startTime = new Date(job.start_timestamp * 1000);
          let $endDateTime = null;
          if (job.end_timestamp) {
            const endTime = new Date(job.end_timestamp * 1000);
            $endDateTime = endTime.toLocaleString(nextState[sdoNs.SESSION].locale);
          }

          job = Object.assign({}, job, {
            $startTime: startTime.toLocaleString(nextState[sdoNs.SESSION].locale),
            $endDateTime,
          });

          if (job.params.skip_notification && job.status === jobStatuses.DONE) {
            continue;
          }

          $notificationBellJobs.push(job);

          if (seenJobs.indexOf(job.id) < 0) {
            $unseenCount++;
          }
        }
        nextState = deepAssign(nextState, ns, {$notificationBellJobs});
        nextState = deepAssign(nextState, ns, {$unseenCount});
      }

      return nextState;
    },
    (nextState) => { // @removeTimestamps
      const state = storeInstance.getState();
      const nextSubState = nextState[ns];
      const subState = state[ns];
      let $doneTimestamps = {};
      try {
        const cached = localStorage.getItem('job-timestamps');
        if (cached !== null) {
          $doneTimestamps = JSON.parse(cached);
        }
      } catch (e) {
      }

      if (typeof nextSubState.$doneTimestamps === 'undefined') {
        nextState = deepAssign(nextState, ns, {$doneTimestamps});
      } else if (nextSubState.jobs !== subState.jobs) {
        for (let i = 0; i < nextSubState.jobs.length; i++) {
          const job = nextSubState.jobs[i];
          if (typeof $doneTimestamps[job.id] === 'undefined' && UserJobs.isDone(job)) {
            $doneTimestamps[job.id] = Date.now() + 120000; // 2 minutes from now
            nextState = deepAssign(nextState, ns, {$doneTimestamps});
          }
        }
        localStorage.setItem('job-timestamps', JSON.stringify($doneTimestamps));
      }

      return nextState;
    },
    (nextState) => { // @activeJobs
      const state = storeInstance.getState();
      const nextSubState = nextState[ns];
      const subState = state[ns];

      const $activeJobs = [];
      const cached = localStorage.getItem('dismissed_jobs');
      let dismissed_jobs = [];
      if (cached !== null) {
        dismissed_jobs = JSON.parse(cached);
      }

      if (typeof nextSubState.$activeJobs === 'undefined') {
        nextState = deepAssign(nextState, ns, {$activeJobs});
      } else if (nextSubState.jobs !== subState.jobs ||
        dismissed_jobs !== subState.$dismissedJobs) {
        const now = Date.now();
        for (let i = 0; i < nextSubState.jobs.length; i++) {
          const job = nextSubState.jobs[i];

          if (dismissed_jobs.indexOf(job.id) >= 0
            || (job.params.skip_notification && job.status === jobStatuses.DONE)) {
            continue;
          }

          if (!UserJobs.isDone(job)) {
            $activeJobs.push(job);
          } else if (typeof nextSubState.$doneTimestamps[job.id] === 'undefined' ||
            nextSubState.$doneTimestamps[job.id] > now) {
            $activeJobs.push(job);
          }
        }
        nextState = deepAssign(nextState, ns, {$activeJobs});
      }

      return nextState;
    },
    (nextState) => { // @activeRosterJob
      const state = storeInstance.getState();
      const nextSubState = nextState[ns];
      const subState = state[ns];

      let $activeRosterJob = {};

      if (typeof nextSubState.$activeRosterJob === 'undefined') {
        nextState = deepAssign(nextState, ns, {$activeRosterJob});
      } else if (nextSubState.rosterJobs !== subState.rosterJobs && nextSubState.rosterJobs.length > 0) {
        $activeRosterJob = nextSubState.rosterJobs[0];
        nextState = deepAssign(nextState, ns, {$activeRosterJob});
      } else if (nextSubState.jobs !== subState.jobs && typeof nextSubState.$activeRosterJob.id !== 'undefined') {
        for (let i = 0; i < nextSubState.jobs.length; i++) {
          const job = nextSubState.jobs[i];
          if (job.id === nextSubState.$activeRosterJob.id) {
            nextState = deepAssign(nextState, `${ns}.$activeRosterJob`, {
              stage: job.stage,
              status: job.status
            });
          }
        }
      }

      return nextState;
    },
    (nextState) => { // $rosterInvalidHeaderPropertyError
      const state = storeInstance.getState();
      const nextSubState = nextState[ns];
      const subState = state[ns];

      let $rosterInvalidHeaderPropertyError = false;

      if (typeof nextSubState.$rosterInvalidHeaderPropertyError === 'undefined') {
        nextState = deepAssign(nextState, ns, {$rosterInvalidHeaderPropertyError});
      } else if (nextSubState.$activeRosterJob !== subState.$activeRosterJob) {
        if (Array.isArray(nextSubState.$activeRosterJob?.errors) &&
          nextSubState.$activeRosterJob.errors.length > 0) {
          $rosterInvalidHeaderPropertyError = nextSubState.$activeRosterJob.errors.some((item) => {
            return item.type === rosterErrors.CSV_INVALID_PROPERTY || item.type === rosterErrors.INVALID_TIERS;
          });
        }

        nextState = deepAssign(nextState, ns, {$rosterInvalidHeaderPropertyError});
      }

      return nextState;
    },
    (nextState) => { // $rosterInvalidColumnCountError
      const state = storeInstance.getState();
      const nextSubState = nextState[ns];
      const subState = state[ns];

      let $rosterInvalidColumnCountError = false;

      if (typeof nextSubState.$rosterInvalidColumnCountError === 'undefined') {
        nextState = deepAssign(nextState, ns, {$rosterInvalidColumnCountError});
      } else if (nextSubState.$activeRosterJob !== subState.$activeRosterJob) {
        if (Array.isArray(nextSubState.$activeRosterJob?.errors) &&
          nextSubState.$activeRosterJob.errors.length > 0) {
          $rosterInvalidColumnCountError = nextSubState.$activeRosterJob.errors.some((item) => {
            return item.type === rosterErrors.CSV_INVALID_COLUMN_COUNT;
          });
        }

        nextState = deepAssign(nextState, ns, {$rosterInvalidColumnCountError});
      }

      return nextState;
    },
    (nextState) => { // $rosterRowError
      const state = storeInstance.getState();
      const nextSubState = nextState[ns];
      const subState = state[ns];

      let $rosterRowError = false;

      if (typeof nextSubState.$rosterRowError === 'undefined') {
        nextState = deepAssign(nextState, ns, {$rosterRowError});
      } else if (nextSubState.$activeRosterJob !== subState.$activeRosterJob) {
        if (Array.isArray(nextSubState.$activeRosterJob?.errors) &&
          nextSubState.$activeRosterJob.errors.length > 0) {
          $rosterRowError = nextSubState.$activeRosterJob.errors.some((item) => {
            return ROSTER_ROW_ERRORS[item.type] || false;
          });
        }

        nextState = deepAssign(nextState, ns, {$rosterRowError});
      }

      return nextState;
    },
    (nextState) => { // $rosterUploadUrl
      const state = storeInstance.getState();
      const nextSubState = nextState[ns];
      const subState = state[ns];

      if (typeof nextSubState.$rosterUploadUrl === 'undefined' ||
        nextSubState.$activeRosterJob !== subState.$activeRosterJob) {
        let $rosterUploadUrl;
        if (nextSubState.$activeRosterJob.params_json?.data_type === 'oneroster') {
          $rosterUploadUrl = pages.ROSTERS_UPLOAD_ONEROSTER;
        } else {
          $rosterUploadUrl = nextSubState.$activeRosterJob.job_type === jobTypes.ROSTER_FULL ?
            pages.ROSTERS_UPLOAD_FULL : pages.ROSTERS_UPLOAD_NEW;
        }

        nextState = deepAssign(nextState, ns, {$rosterUploadUrl});
      }

      return nextState;
    },
    (nextState) => { // $rosterFiles
      const state = storeInstance.getState();
      const nextSubState = nextState[ns];
      const subState = state[ns];

      if (typeof nextSubState.$rosterFiles === 'undefined' ||
        nextSubState.rosterJobs !== subState.rosterJobs ||
        nextState[sdoNs.SESSION].locale !== state[sdoNs.SESSION].locale) {
        const $rosterFiles = [];

        for (let i = 0; i < nextSubState.rosterJobs.length; i++) {
          const rosterJob = nextSubState.rosterJobs[i];

          if (rosterJob.status === jobStatuses.DONE) {
            const startTime = getLocaleDate(rosterJob.end_timestamp * 1000, nextState[sdoNs.SESSION].locale, {
              hour: '2-digit',
              minute: '2-digit'
            });

            let name = `${startTime} - `;
            switch (rosterJob.params_json.data_type) {
              case 'aofl':
                name += rosterJob.params_json.original_filename;
                break;
              case 'clever':
              case 'classlink':
                name += thirdPartyRosterSystemsMap[rosterJob.params_json.data_type];
                break;
            }

            $rosterFiles.push({
              id: rosterJob.id,
              name,
            });
          }
        }

        nextState = deepAssign(nextState, sdoNs.USER_JOBS, {$rosterFiles});
      }

      return nextState;
    },
    (nextState) => { // $userJobsById
      const state = storeInstance.getState();
      const nextSubState = nextState[ns];
      const subState = state[ns];

      if (typeof nextSubState.$userJobsById === 'undefined' ||
        nextSubState.jobs !== subState.jobs) {
        const $userJobsById = {};

        for (let i = 0; i < nextSubState.jobs.length; i++) {
          const job = nextSubState.jobs[i];
          $userJobsById[String(job.id)] = job;
        }


        nextState = deepAssign(nextState, ns, {$userJobsById});
      }

      return nextState;
    },
    (nextState) => { // $dismissedJobs
      const state = storeInstance.getState();
      const subState = state[ns];

      try {
        const cached = localStorage.getItem('dismissed_jobs');
        if (cached !== null && JSON.stringify(subState.$dismissedJobs) !== cached) {
          const $dismissedJobs = JSON.parse(cached);
          nextState = deepAssign(nextState, ns, {$dismissedJobs});
        }
      } catch (e) {
      }

      return nextState;
    },
    (nextState) => { // $seenBellJobs
      const state = storeInstance.getState();
      const subState = state[ns];

      try {
        const cached = localStorage.getItem('seen_bell_jobs');
        if (cached !== null && JSON.stringify(subState.$seenBellJobs) !== cached) {
          const $seenBellJobs = JSON.parse(cached);
          nextState = deepAssign(nextState, ns, {$seenBellJobs});
        }
      } catch (e) {
      }

      return nextState;
    },
    (nextState) => { // $filteredRosters
      const state = storeInstance.getState();
      const nextSubState = nextState[ns];
      const subState = state[ns];

      if (nextSubState.rosterJobs.length > 0 && (
        typeof nextSubState.$filteredRosters === 'undefined' ||
        nextSubState.rosterJobs !== subState.rosterJobs)) {
        const thirdPartySystem = state[sdoNs.SESSION].settings.third_party_rostering_system;
        let $filteredRosters = nextSubState.rosterJobs;
        // Third parties can view rosterJobs from all levels
        if (!thirdPartySystem) {
          const currentLevel = state[sdoNs.SESSION].group_info.level;
          $filteredRosters = nextSubState.rosterJobs.filter((rosterJob) => {
            return rosterJob.params_json.current_tier === currentLevel;
          });
        }
        nextState = deepAssign(nextState, ns, {$filteredRosters});
      }
      return nextState;
    }
  ]
};

storeInstance.addState(sdo);
